import { phoenixSearch } from '@phoenix/search/PhoenixSearch';
import AlgoliaSearch, { algoliaSearch } from './algolia/AlgoliaSearch';

export const searchClient = AlgoliaSearch.isEnabled() ? algoliaSearch : phoenixSearch;
